module.exports = __webpack_public_path__ + "static/logo-cv-40a5aee05d635ea19819099ce6d92782.png";